var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapmarker = function SvgMapmarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mapmarker_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mapmarker_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.13 2.217C7.993 2.217 3 7.407 3 13.79c0 7.999 9.807 16.916 10.225 17.291.261.235.583.354.905.354.323 0 .645-.119.906-.354.418-.375 10.225-9.292 10.225-17.29 0-6.383-4.994-11.574-11.13-11.574Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.13 2.217C7.993 2.217 3 7.407 3 13.79c0 7.999 9.807 16.916 10.225 17.291.261.235.583.354.905.354.323 0 .645-.119.906-.354.418-.375 10.225-9.292 10.225-17.29 0-6.383-4.994-11.574-11.13-11.574Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.225 31.081-1.338 1.487 1.338-1.487Zm1.811 0 1.337 1.487-1.337-1.487ZM14.13.217C6.816.217 1 6.377 1 13.79h4c0-5.352 4.17-9.573 9.13-9.573v-4ZM1 13.79c0 4.704 2.823 9.39 5.367 12.719 2.61 3.416 5.269 5.833 5.52 6.06l2.675-2.975c-.166-.149-2.62-2.378-5.017-5.514C7.08 20.856 5 17.085 5 13.79H1Zm10.887 18.778a3.35 3.35 0 0 0 2.243.867v-4a.65.65 0 0 1 .432.159l-2.675 2.974Zm2.243.867a3.35 3.35 0 0 0 2.243-.867L13.7 29.594a.65.65 0 0 1 .431-.16v4Zm2.244-.867c.251-.226 2.91-2.643 5.52-6.06 2.544-3.327 5.367-8.014 5.367-12.718h-4c0 3.295-2.08 7.066-4.545 10.29-2.397 3.136-4.852 5.365-5.017 5.514l2.675 2.974ZM27.26 13.79C27.26 6.377 21.445.217 14.13.217v4c4.96 0 9.13 4.221 9.13 9.573h4Z",
    fill: "#008545",
    mask: "url(#mapmarker_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.131,
    cy: 13.348,
    r: 4.174,
    fill: "#008545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mapmarker_svg__a",
    x: 0,
    y: 0.217,
    width: 28.262,
    height: 35.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1702_43032"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1702_43032",
    result: "effect2_dropShadow_1702_43032"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1702_43032",
    result: "shape"
  })))));
};
export default SvgMapmarker;